import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MainPipe } from 'src/app/common/mainpipe.module';
import { FooterComponent } from './footer.component';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [FooterComponent],
  imports: [
    CommonModule, 
    MainPipe,
    FormsModule
  ],
  exports: [FooterComponent],
})
export class FooterModule {
  getComponent() {
    return FooterComponent;
  }
}
